import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  AddCarInCarAgent,
  UppdateCarInCarAgent,
  DeleteCarInCarAgent,
  getCarAgentCarListing,
  getCarBrand,
  getCarModels,
  getCarModelYear,
  getCarCylinder,
  getCarFuelType,
  getCarSeat,
  getCarDoor,
  getCarColor,
  getCarSafety,
  getCarComfort,
  reorderCarAgentCars,
} from './../../../../Redux/Actions/UserAction';

import axios from 'axios';
import { set } from 'react-hook-form';
import { CarAgentCommonHeader } from './CarAgentCommonHeader';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

// const API = "https://api.carsavenue.com/api";
const API = 'https://api.carsavenue.com/api';

const config = () => ({
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
});

export default function CarAgentCars() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  // Render the right label for the active language: English field for English,
  // Arabic (`*Ar`) field for Arabic, with a fallback to whichever exists.
  const lang = (i18n.language || 'en').toLowerCase().startsWith('ar')
    ? 'ar'
    : 'en';
  const L = (en, ar) => (lang === 'ar' ? ar || en : en || ar);

  // Numeric option lists must be sorted (the API returns them unordered).
  const sortNum = (arr, key, desc) =>
    Array.isArray(arr)
      ? [...arr].sort((a, b) =>
          desc
            ? Number(b[key]) - Number(a[key])
            : Number(a[key]) - Number(b[key])
        )
      : [];

  // Empty dropdowns post '' which is an invalid UUID for the FK columns and
  // makes the backend reject the whole car. Convert blanks to null so optional
  // fields are simply omitted.
  const clean = (obj) => {
    const out = {};
    Object.keys(obj).forEach((k) => {
      out[k] = obj[k] === '' ? null : obj[k];
    });
    return out;
  };

  // Close the Add/Edit Car modal after a successful submit. The modal is opened
  // via legacy data-toggle, so try Bootstrap 5, then jQuery, then a manual DOM
  // teardown as a last resort — whichever is active.
  const closeAddCarModal = () => {
    const el = document.getElementById('add-new-car');
    if (!el) return;
    try {
      // eslint-disable-next-line global-require
      const { Modal } = require('bootstrap');
      (Modal.getInstance(el) || Modal.getOrCreateInstance(el)).hide();
    } catch (e) {}
    try {
      if (window.$ && window.$(el).modal) window.$(el).modal('hide');
    } catch (e) {}
    // Fallback: if still visible, tear the modal down manually.
    setTimeout(() => {
      if (el.classList.contains('show') || el.style.display === 'block') {
        el.classList.remove('show');
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.querySelectorAll('.modal-backdrop').forEach((b) => b.remove());
    }, 60);
  };

  const [update, setUpdate] = useState('');

  const home = useSelector((state) => state?.home);

  const carListing = home?.CarDealerCarList;

  const CarBrand = home?.garageCarBrandList;
  // Brand-linked car models for the model dropdown (falls back to free text).
  const CarModels = home?.carModels;
  const CarModelYear = home?.CarModelYears;
  const CarCylinder = home?.CarCylinders;
  const CarFuelType = home?.CarFuelTypes;
  const CarSeat = home?.CarSeats;
  const CarDoor = home?.CarDoors;
  const CarColor = home?.CarColors;
  const CarSafety = home?.CarSafety;
  const CarComfort = home?.CarComfort;

  useEffect(() => {
    dispatch(getCarAgentCarListing());
    dispatch(getCarBrand());
    dispatch(getCarModelYear());
    dispatch(getCarCylinder());
    dispatch(getCarFuelType());
    dispatch(getCarSeat());
    dispatch(getCarDoor());
    dispatch(getCarColor());
    dispatch(getCarSafety());
    dispatch(getCarComfort());
  }, []);

  const [ImageBlob, setImageBlob] = useState([]);
  const [File, setFile] = useState([]);

  // [CF] Primary image: index (within ImageBlob preview order) the owner marked
  // as the cover. The submitted mediaIds array is reordered so this image is
  // FIRST (backend treats index 0 as the cover).
  const [primaryIndex, setPrimaryIndex] = useState(0);

  const [AddCarDetail, setAddCarDetail] = useState({
    carName: '',
    category: '',
    description: '',
    carModel: '',
    doorId: '',
    seatId: '',
    kilometerDriven: '',
    interiorColorId: '',
    exteriorColorId: '',
    cyclinderId: '',
    carBrandId: '',
    modelYearId: '',
    fuelTypeId: '',
  });

  const [Safety, setSafety] = useState([]);
  const [Comfort, setComforty] = useState([]);

  const handleSafetyChange = (event) => {
    var checkedItem = event.target.value;

    let newArray = [...Safety, checkedItem];

    if (Safety.includes(checkedItem)) {
      newArray = newArray.filter((safe) => safe !== checkedItem);
    }

    setSafety(newArray);
  };

  const handleComfortChange = (event) => {
    var checkedItem = event.target.value;

    let newArray = [...Comfort, checkedItem];

    if (Comfort.includes(checkedItem)) {
      newArray = newArray.filter((comf) => comf !== checkedItem);
    }

    setComforty(newArray);
  };

  // [CF] Image multi-select: blob indices the owner ticked for bulk deletion.
  const [selectedForDelete, setSelectedForDelete] = useState([]);

  const toggleSelectForDelete = (index) => {
    setSelectedForDelete((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleRemoveClick = (index) => {
    const list = [...ImageBlob];
    list.splice(index, 1);
    setImageBlob(list);

    // ImageBlob is [existing..., new...]; File only holds the NEW files. Map the
    // blob index into File space before splicing so removing an existing image
    // doesn't wrongly drop a freshly-added file.
    const existingLen = (AddCarDetail?.mediaIds?.CAR_IMAGE || []).length;
    if (index >= existingLen) {
      const Filelist = [...File];
      Filelist.splice(index - existingLen, 1);
      setFile(Filelist);
    }

    // Drop the matching saved mediaId so the deleted image isn't re-sent on save.
    setAddCarDetail((prev) => {
      const existing = prev?.mediaIds?.CAR_IMAGE || [];
      if (index >= existing.length) return prev; // a newly-added file
      const nextIds = [...existing];
      nextIds.splice(index, 1);
      return { ...prev, mediaIds: { CAR_IMAGE: nextIds } };
    });

    // [CF] Keep the primary selection pointing at the same image after a remove.
    setPrimaryIndex((prev) => {
      if (index === prev) return 0; // removed the primary -> fall back to first
      return index < prev ? prev - 1 : prev;
    });

    setSelectedForDelete((prev) =>
      prev.filter((i) => i !== index).map((i) => (i > index ? i - 1 : i))
    );
  };

  // [CF] Bulk-delete every ticked thumbnail in one pass.
  const handleDeleteSelected = () => {
    if (!selectedForDelete.length) return;
    const toRemove = new Set(selectedForDelete);
    const existingLen = (AddCarDetail?.mediaIds?.CAR_IMAGE || []).length;

    setImageBlob((prev) => prev.filter((_, i) => !toRemove.has(i)));
    setFile((prev) => prev.filter((_, fi) => !toRemove.has(fi + existingLen)));
    setAddCarDetail((prev) => {
      const existing = prev?.mediaIds?.CAR_IMAGE || [];
      return {
        ...prev,
        mediaIds: { CAR_IMAGE: existing.filter((_, i) => !toRemove.has(i)) },
      };
    });
    setPrimaryIndex((prev) => {
      if (toRemove.has(prev)) return 0;
      const removedBefore = selectedForDelete.filter((i) => i < prev).length;
      return Math.max(0, prev - removedBefore);
    });
    setSelectedForDelete([]);
  };

  const handleUploadImage = (event) => {
    // Bulk upload: process EVERY selected file (was files[0] only), appending
    // each to the File array and generating a preview for each.
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    setFile((prev) => [...prev, ...files]);
    files.forEach((file) => {
      const reader = new FileReader(file);
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setImageBlob((prev) => [...prev, reader.result]);
      };
    });

    // Reset so re-selecting the same files re-triggers onChange.
    event.target.value = '';
  };

  const handleAddCarDtetail = (e) => {
    const { name, value } = e.target;
    setAddCarDetail((user) => ({ ...user, [name]: value }));

    console.log('this is car dealer', AddCarDetail);
  };

  // Load brand-linked car models whenever the selected brand changes.
  useEffect(() => {
    if (AddCarDetail?.carBrandId) {
      dispatch(getCarModels(AddCarDetail.carBrandId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AddCarDetail?.carBrandId]);

  // Guard against double-submit (a fast second click would post a duplicate car).
  const submittingRef = useRef(false);

  // [CF] Move the owner-selected primary image to the front of the media array
  // (index 0 = cover on the backend). MediaIDs is ordered the same as the
  // uploaded File list / ImageBlob previews, so primaryIndex lines up.
  const reorderPrimaryFirst = (mediaIds) => {
    if (
      !Array.isArray(mediaIds) ||
      primaryIndex <= 0 ||
      primaryIndex >= mediaIds.length
    )
      return mediaIds;
    const arr = [...mediaIds];
    const [primary] = arr.splice(primaryIndex, 1);
    arr.unshift(primary);
    return arr;
  };

  // Build the payload and dispatch add/update with the final image set.
  const submitCar = (finalMediaIds) => {
    // Auto-generate the car name from Brand + Model/Series + Year (consistent
    // with the other categories — no manual name field).
    const brandObj = (CarBrand || []).find(
      (b) => b.brandId === AddCarDetail.carBrandId
    );
    const yearObj = (CarModelYear || []).find(
      (y) => y.modelYearId === AddCarDetail.modelYearId
    );
    const autoCarName =
      [
        brandObj?.name || brandObj?.nameAr,
        AddCarDetail.carModel,
        yearObj?.modelYear,
      ]
        .filter(Boolean)
        .join(' ') || 'Car';

    const base = {
      ...clean(AddCarDetail),
      carName: autoCarName,
      safetyId: Safety,
      comfortId: Comfort,
      mediaIds: { CAR_IMAGE: finalMediaIds },
    };

    if (update !== '') {
      dispatch(UppdateCarInCarAgent({ ...base, carId: update }));
    } else {
      dispatch(AddCarInCarAgent(base));
    }
    closeAddCarModal();
    submittingRef.current = false;
  };

  const UploadImage = (event) => {
    // On edit, the car's already-saved image ids (set in onCarEdit) let the
    // owner save WITHOUT re-uploading images. Combine kept-existing + new.
    const existingMediaIds = (AddCarDetail?.mediaIds?.CAR_IMAGE || []).filter(
      Boolean
    );
    const hasExisting = existingMediaIds.length > 0;
    const hasNew = File && File.length > 0;

    if (!hasExisting && !hasNew) {
      Swal.fire({
        title: 'Please upload at least one car image',
        icon: 'warning',
      });
      return;
    }

    if (submittingRef.current) return;
    submittingRef.current = true;

    // No new images — keep the existing set (primary moved to front).
    if (!hasNew) {
      submitCar(reorderPrimaryFirst([...existingMediaIds]));
      return;
    }

    const formData = new FormData();
    File.forEach((file) => {
      formData.append('media', file);
    });

    axios
      .post(API + '/media/new', formData, config())
      .then((res) => {
        const newIds = [
          ...new Set(res.data.response.media.map((d) => d.mediaId)),
        ];
        submitCar(reorderPrimaryFirst([...existingMediaIds, ...newIds]));
      })
      .catch((err) => {
        submittingRef.current = false;
        Swal.fire({
          title:
            err?.response?.data?.response?.message ||
            err?.response?.data?.message ||
            'Image upload failed. Please try again.',
          icon: 'error',
        });
      });
  };

  const datasubmit = () => {
    UploadImage();
  };

  const handlerReset = () => {
    setUpdate('');
    setAddCarDetail({
      carName: '',
      category: '',
      description: '',
      // carModel: "",
      doorId: '',
      seatId: '',
      kilometerDriven: '',
      interiorColorId: '',
      exteriorColorId: '',
      cyclinderId: '',
      carBrandId: '',
      modelYearId: '',
      fuelTypeId: '',
    });
    setSafety([]);
    setComforty([]);
    setImageBlob([]);
    setFile([]);
    setPrimaryIndex(0); // [CF] reset primary selection
    setSelectedForDelete([]); // [CF] clear image multi-select
  };

  const onCarEdit = (carDetails) => {
    console.log('carDetails', carDetails);
    setUpdate(carDetails.carId);

    var carMediaData = [
      ...new Set(carDetails.carMedia.map((data) => data?.media?.mediaId)),
    ];

    setAddCarDetail({
      carName: carDetails.carName,
      category: carDetails.category,
      description: carDetails.description,
      // carModel: carDetails.carModel,
      doorId: carDetails.doorId,
      seatId: carDetails.seatId,
      kilometerDriven: carDetails.kilometerDriven,
      interiorColorId: carDetails.interiorColorId,
      exteriorColorId: carDetails.exteriorColorId,
      cyclinderId: carDetails.cyclinderId,
      carBrandId: carDetails.carBrandId,
      modelYearId: carDetails.modelYearId,
      fuelTypeId: carDetails.fuelTypeId,
      mediaIds: {
        CAR_IMAGE: carMediaData,
      },
    });
    var safetyIDs = [
      ...new Set(carDetails.safetyId.map((data) => data.safetyId)),
    ];
    setSafety(safetyIDs);

    var comfertIDs = [
      ...new Set(carDetails.comfortId.map((data) => data.comfortId)),
    ];
    setComforty(comfertIDs);

    var ImageUrls = [
      ...new Set(carDetails.carMedia.map((data) => data?.media?.path)),
    ];
    setImageBlob(ImageUrls);
    setFile([]); // [CF] editing starts with no newly-added files
    setPrimaryIndex(0); // [CF] existing cover is already first
    setSelectedForDelete([]); // [CF] clear image multi-select
  };

  console.log('AddCarDetail', AddCarDetail);
  console.log('Safety', Safety);
  console.log('Comfort', Comfort);

  // [CF] Drag-to-reorder the car grid. `orderList` is an optimistic local copy
  // of the listing; mutated live during a drag and persisted silently on drop.
  const [orderList, setOrderList] = useState([]);
  const [dragIndex, setDragIndex] = useState(null);

  useEffect(() => {
    setOrderList(Array.isArray(carListing) ? carListing : []);
  }, [carListing]);

  const onDragStart = (index) => () => setDragIndex(index);

  const onDragEnter = (index) => () => {
    if (dragIndex === null || dragIndex === index) return;
    setOrderList((prev) => {
      const next = [...prev];
      const [moved] = next.splice(dragIndex, 1);
      next.splice(index, 0, moved);
      return next;
    });
    setDragIndex(index);
  };

  const onDragEndPersist = () => {
    setDragIndex(null);
    const ids = orderList.map((c) => c?.carId).filter(Boolean);
    if (ids.length) dispatch(reorderCarAgentCars(ids));
  };

  const onCarDelete = (carId) => {
    // [CF-15] Confirm before deleting (was deleting instantly).
    Swal.fire({
      title: t('Are you sure?'),
      text: t('This item will be permanently deleted.'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('Yes, delete it'),
      cancelButtonText: t('Cancel'),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(DeleteCarInCarAgent({ carId: carId }));
      }
    });
  };

  return (
    <div>
      <CarAgentCommonHeader />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
              <div class="side-package">
                <div class="line-a">PACKAGE</div>
                <div class="line-b">
                  <div class="side-package-progress">
                    <span class="eighty"></span>
                  </div>
                </div>
                <div class="line-c">30 days remaining</div>
                <div class="line-d">Validity till 02 March 2021</div>
                <div class="line-e">
                  <a class="btn btn-dark btn-sm" href="#" role="button">
                    UPDATE
                  </a>
                </div>
              </div>

              <div class="side-links-wrap">
                <ul>
                  <li>
                    <Link to="/sp-cars-agents-business">
                      <img
                        src="assets/images/icons/sp-business/manage-business.svg"
                        alt=""
                      />{' '}
                      Manage Business
                    </Link>
                  </li>
                  {/* <li>
										<Link to='/sp-cars-agents-categories'>
											<img
												src='assets/images/icons/sp-business/manage-service.svg'
												alt=''
											/>{' '}
											Manage Categories
										</Link>
									</li> */}
                  <li>
                    <Link to="/sp-cars-agents-cars" class="active">
                      <img
                        src="assets/images/icons/sp-business/manage-service.svg"
                        alt=""
                      />{' '}
                      Manage Cars
                    </Link>
                  </li>
                  <li>
                    <Link to="/sp-cars-agents-banner">
                      <img
                        src="assets/images/icons/sp-business/banner.svg"
                        alt=""
                      />{' '}
                      Banner
                    </Link>
                  </li>
                  <li>
                    <Link to="/sp-cars-agents-working-hours">
                      <img
                        src="assets/images/icons/sp-business/manage-working-hours.svg"
                        alt=""
                      />{' '}
                      Manage Working Hours
                    </Link>
                  </li>
                  {/* <li>
										<Link to='/sp-cars-agents-showroom'>
											<img
												src='assets/images/service-icons/garage.svg'
												alt=''
											/>{' '}
											Manage Showroom
										</Link>
									</li>
									<li>
										<Link to='/sp-cars-agents-workshop'>
											<img
												src='assets/images/service-icons/car-wash.svg'
												alt=''
											/>{' '}
											Manage Workshop
										</Link>
									</li> */}
                </ul>
              </div>
            </div>

            <div
              class="modal fade"
              id="add-new-car"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Add new Car
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <form>
                      <div class="form-group">
                        <label for="anc-car-model">Car Category</label>
                        <input
                          name="category"
                          value={AddCarDetail.category}
                          onChange={handleAddCarDtetail}
                          type="text"
                          class="form-control"
                          placeholder={t("Enter Car Category")}
                        />
                      </div>

                      <div class="form-group">
                        <label for="anc-car-brand">Select Car Brand</label>
                        <select
                          class="form-control"
                          id="anc-car-brand"
                          name="carBrandId"
                          onChange={handleAddCarDtetail}
                          value={AddCarDetail.carBrandId}
                        >
                          <option>{t('- Select Car Brand -')}</option>
                          {CarBrand !== undefined && CarBrand.length
                            ? CarBrand.map((brand, idx) => (
                                <option value={brand.brandId}>
                                  {L(brand.name, brand.nameAr)}
                                </option>
                              ))
                            : null}
                        </select>
                      </div>

                      <div class="form-group">
                        <label for="anc-car-model">
                          {t('Car Model and Series')}
                        </label>
                        {Array.isArray(CarModels) && CarModels.length ? (
                          <select
                            class="form-control"
                            id="anc-car-model"
                            name="carModel"
                            value={AddCarDetail.carModel}
                            onChange={handleAddCarDtetail}
                          >
                            <option value="">
                              {' '}
                              - {t('Select Car Model')} -{' '}
                            </option>
                            {CarModels.map((model, idx) => (
                              <option key={idx} value={model.name}>
                                {L(model.name, model.nameAr)}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            name="carModel"
                            value={AddCarDetail.carModel}
                            onChange={handleAddCarDtetail}
                            type="text"
                            class="form-control"
                            placeholder={t('Enter Car Model')}
                          />
                        )}
                      </div>
                      <div class="btn btn-primary btn-file">
                        <label
                          class="btn text-white upload-button btn-sm"
                          for="files"
                        >
                          <i class="fas fa-folder-open"></i> &nbsp; Upload your
                          Car Images …
                        </label>
                        <input
                          type="file"
                          id="files"
                          accept="image/*"
                          multiple
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>

                      {/* [CF] Bulk image actions: appears once one or more
                          thumbnails are ticked. Delete several images at once. */}
                      {ImageBlob?.length > 0 && (
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <small className="text-muted">
                            {selectedForDelete.length > 0
                              ? `${selectedForDelete.length} ${t('selected')}`
                              : t('Tick images to delete multiple at once')}
                          </small>
                          {selectedForDelete.length > 0 && (
                            <button
                              type="button"
                              class="btn btn-sm btn-danger"
                              onClick={handleDeleteSelected}
                            >
                              <i class="far fa-trash-alt"></i>{' '}
                              {t('Delete selected')} ({selectedForDelete.length})
                            </button>
                          )}
                        </div>
                      )}
                      <div class="form-group">
                        <div class="row align-items-center ">
                          {ImageBlob?.map((item, indexValue) => {
                            // [CF] Primary image selection: highlight the cover
                            // and let the owner mark any thumbnail as primary.
                            const isPrimary = indexValue === primaryIndex;
                            const isChecked =
                              selectedForDelete.includes(indexValue);
                            return (
                              <div class="col-auto">
                                <div
                                  class=" row-cols-7"
                                  style={{
                                    border: isChecked
                                      ? '2px solid #dc3545'
                                      : isPrimary
                                      ? '2px solid #ffc107'
                                      : '2px solid transparent',
                                    borderRadius: '6px',
                                    padding: '2px',
                                  }}
                                >
                                  <div class="d-flex align-items-center justify-content-between">
                                    <label
                                      class="m-0"
                                      style={{
                                        fontSize: '0.7rem',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={isChecked}
                                        onChange={() =>
                                          toggleSelectForDelete(indexValue)
                                        }
                                      />
                                      {t('Select')}
                                    </label>
                                    <button
                                      type="button"
                                      class="close"
                                      // data-dismiss='modal'
                                      onClick={() =>
                                        handleRemoveClick(indexValue)
                                      }
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <img
                                    style={{
                                      height: '5rem',
                                      width: '8rem',
                                    }}
                                    class="profile-pic img-fluid m-1"
                                    // src='assets/images/camera.jpg'
                                    // src='/Screenshot (4).png'
                                    src={
                                      item !== undefined
                                        ? item
                                        : 'assets/images/camera.jpg'
                                    }
                                    alt=""
                                  />
                                  {isPrimary ? (
                                    <div
                                      class="text-center"
                                      style={{
                                        fontSize: '0.7rem',
                                        color: '#ffc107',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      <i class="fas fa-star"></i> {t('Primary')}
                                    </div>
                                  ) : (
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-outline-warning w-100"
                                      style={{ fontSize: '0.7rem' }}
                                      onClick={() => setPrimaryIndex(indexValue)}
                                    >
                                      {t('Set as primary')}
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="anc-description">
                          Car Description <small>(Optional)</small>
                        </label>
                        <textarea
                          name="description"
                          value={AddCarDetail.description}
                          onChange={handleAddCarDtetail}
                          class="form-control"
                          id="anc-description"
                          rows="3"
                        ></textarea>
                      </div>

                      <div class="form-group">
                        <label for="anc-cyclinder">Cyclinder</label>
                        <select
                          class="form-control"
                          id="anc-cyclinder"
                          name="cyclinderId"
                          value={AddCarDetail.cyclinderId}
                          onChange={handleAddCarDtetail}
                        >
                          <option> - Select Cyclinder Type - </option>
                          {sortNum(CarCylinder, 'cyclinder').map(
                            (cylinder, idx) => (
                              <option value={cylinder.cyclinderId}>
                                {cylinder.cyclinder}
                              </option>
                            )
                          )}
                        </select>
                      </div>

                      <div class="form-group">
                        <label for="anc-kilometer-driven">
                          Kilometer Driven
                        </label>
                        <input
                          name="kilometerDriven"
                          value={AddCarDetail.kilometerDriven}
                          onChange={handleAddCarDtetail}
                          type="text"
                          class="form-control"
                          id="anc-kilometer-driven"
                          placeholder={t("Kilometer Driven")}
                        />
                      </div>

                      <div class="form-group">
                        <label for="anc-model-year">{t('Model Year')}</label>
                        <select
                          class="form-control"
                          id="anc-model-year"
                          name="modelYearId"
                          value={AddCarDetail.modelYearId}
                          onChange={handleAddCarDtetail}
                        >
                          <option>- Select Car Model Year-</option>
                          {sortNum(CarModelYear, 'modelYear', true).map(
                            (year, idx) => (
                              <option value={year.modelYearId}>
                                {year.modelYear}
                              </option>
                            )
                          )}
                        </select>
                      </div>

                      <div class="form-group">
                        <label for="anc-fuel-type">Fuel Type</label>
                        <select
                          class="form-control"
                          id="anc-fuel-type"
                          name="fuelTypeId"
                          value={AddCarDetail.fuelTypeId}
                          onChange={handleAddCarDtetail}
                        >
                          <option> - Select Fuel Type - </option>
                          {CarFuelType !== undefined && CarFuelType.length
                            ? CarFuelType.map((fuel, idx) => (
                                <option value={fuel.fuelTypeId}>
                                  {L(fuel.fuelType, fuel.fuelTypeAr)}
                                </option>
                              ))
                            : null}
                        </select>
                      </div>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-6">
                            <label for="anc-doors">Doors</label>
                            <select
                              class="form-control"
                              id="anc-doors"
                              name="doorId"
                              value={AddCarDetail.doorId}
                              onChange={handleAddCarDtetail}
                            >
                              <option> - Select Doors Count - </option>
                              {sortNum(CarDoor, 'door').map((door, idx) => (
                                <option value={door.doorId}>{door.door}</option>
                              ))}
                            </select>
                          </div>
                          <div class="col-6">
                            <label for="anc-seats">Seats</label>
                            <select
                              class="form-control"
                              id="anc-seats"
                              name="seatId"
                              value={AddCarDetail.seatId}
                              onChange={handleAddCarDtetail}
                            >
                              <option> - Select Seats Count - </option>
                              {sortNum(CarSeat, 'seat').map((seat, idx) => (
                                <option value={seat.seatId}>{seat.seat}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-6">
                            <label for="anc-interior-color">
                              Interior Color
                            </label>
                            <select
                              name="interiorColorId"
                              value={AddCarDetail.interiorColorId}
                              onChange={handleAddCarDtetail}
                              class="form-control"
                              id="anc-interior-color"
                            >
                              <option> - Select Interior Color - </option>
                              {CarColor !== undefined && CarColor.length
                                ? CarColor.map((color, idx) => (
                                    <option value={color.colorId}>
                                      {L(color.color, color.colorAr)}
                                    </option>
                                  ))
                                : null}
                            </select>
                          </div>
                          <div class="col-6">
                            <label for="anc-exterior-color">
                              Exterior Color
                            </label>
                            <select
                              name="exteriorColorId"
                              value={AddCarDetail.exteriorColorId}
                              onChange={handleAddCarDtetail}
                              class="form-control"
                              id="anc-exterior-color"
                            >
                              <option> - Select Exterior Color - </option>
                              {CarColor !== undefined && CarColor.length
                                ? CarColor.map((color, idx) => (
                                    <option value={color.colorId}>
                                      {L(color.color, color.colorAr)}
                                    </option>
                                  ))
                                : null}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <h5>Safety & Security</h5>
                        <div className="CarForSale_safety">
                          {CarSafety !== undefined && CarSafety.length
                            ? CarSafety.map((safe, idx) => (
                                <div>
                                  <input
                                    type="checkbox"
                                    // name={idx}
                                    id={safe.safetyId}
                                    value={safe.safetyId}
                                    checked={Safety.includes(safe.safetyId)}
                                    onChange={handleSafetyChange}
                                  />
                                  <label htmlFor={safe.safetyId}>
                                    {L(safe.safety, safe.safetyAr)}
                                  </label>
                                </div>
                              ))
                            : null}
                        </div>
                      </div>

                      <div class="form-group">
                        <h5>Comfort and Convienience</h5>
                        <div className="CarForSale_safety">
                          {CarComfort !== undefined && CarComfort.length
                            ? CarComfort.map((comf, idx) => (
                                <div>
                                  <input
                                    type="checkbox"
                                    // name={idx}
                                    id={comf.comfortId}
                                    value={comf.comfortId}
                                    checked={Comfort.includes(comf.comfortId)}
                                    onChange={handleComfortChange}
                                  />
                                  <label htmlFor={comf.comfortId}>
                                    {L(comf.comfort, comf.comfortAr)}
                                  </label>
                                </div>
                              ))
                            : null}
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="reset"
                      class="btn btn-secondary btn-lg"
                      onClick={handlerReset}
                    >
                      {' '}
                      RESET
                    </button>

                    <button
                      class="btn btn-warning btn-lg "
                      // class='close'
                      onClick={datasubmit}
                      data-toggle="modal"
                    >
                      Review &amp; Post
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <div class="row mb-4 align-items-center justify-content-between">
                <div class="col">
                  <h3 class="mb-0">Manage Cars</h3>
                </div>
                <div class="col-auto">
                  <a
                    onClick={handlerReset}
                    class="btn btn-outline-secondary"
                    // href='javascript:void(0);'
                    role="button"
                    data-toggle="modal"
                    data-target="#add-new-car"
                  >
                    + Add new car
                  </a>
                </div>
              </div>

              {orderList?.length > 1 && (
                <p className="text-muted small mb-2">
                  <i class="fas fa-arrows-alt"></i>{' '}
                  {t('Drag cars to reorder how they appear')}
                </p>
              )}
              <div class="row">
                {orderList !== undefined && orderList.length
                  ? orderList?.map((car, idx) => {
                      return (
                        <>
                          <div
                            class="col-6 col-sm-6 col-md-4 mb-5"
                            draggable
                            onDragStart={onDragStart(idx)}
                            onDragEnter={onDragEnter(idx)}
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnd={onDragEndPersist}
                            onDrop={(e) => e.preventDefault()}
                            style={{
                              cursor: 'move',
                              opacity: dragIndex === idx ? 0.5 : 1,
                            }}
                          >
                            <div class="mc-add-car-block">
                              <div class="line-a">
                                <img
                                  src={car?.carMedia[0]?.media?.path}
                                  // src='assets/images/user/car-dealers/a.jpg'
                                  class="img-fluid"
                                  alt=""
                                />
                                <div class="line-d">
                                  <div class="row">
                                    <div
                                      class="col-auto"
                                      data-toggle="modal"
                                      data-target="#add-new-car"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => onCarEdit(car)}
                                      >
                                        <i class="far fa-edit"></i> Edit
                                      </a>
                                    </div>
                                    <div class="col-auto">
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => onCarDelete(car?.carId)}
                                      >
                                        <i class="far fa-trash-alt"></i> Delete
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="line-b">
                                <div class="line-a">{car?.carName}</div>
                                <div class="line-b">{car?.carModel}</div>
                                <div class="line-c">
                                  <div class="row justify-content-between">
                                    <div class="col-auto">
                                      <span>{car?.modelYear?.modelYear}</span>
                                    </div>
                                    <div class="col-auto">
                                      {car?.kilometerDriven} KM
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })
                  : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
